// skipcq: JS-W1028
import { Link } from 'react-router-dom';
import {
  CardContent,
  CardActions,
  Button,
  Typography,
  CircularProgress,
  Box,
} from '@mui/material';
import useBeerIngestionFailures from '../../hooks/useBeerIngestionFailures';
import { BEER_INGESTION_DEFAULT_STATE } from '../../utils/callableBeerConstants';
import DashboardSurfaceCard from './DashboardSurfaceCard';

function BeerIngestionIssuesCard() {
  const { summary, loading, error } = useBeerIngestionFailures(BEER_INGESTION_DEFAULT_STATE);

  return (
    <DashboardSurfaceCard>
      <CardContent sx={{ flexGrow: 1 }}>
        <Typography variant="h6" component="h2" gutterBottom>
          Beer Ingestion Issues
        </Typography>
        <Typography variant="body2" paragraph sx={{ color: 'text.secondary' }}>
          Monitor and recover failed beer-source checks and extractions
        </Typography>

        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 2 }}>
            <CircularProgress size={24} />
          </Box>
        ) : error ? (
          <Typography variant="body2" color="error">
            Error loading data
          </Typography>
        ) : (
          <>
            <Typography variant="h4" component="div" sx={{ color: 'warning.main' }}>
              {summary.open.toLocaleString()}
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              Open failures
            </Typography>
            {summary.autoPausedCount > 0 ? (
              <>
                <Typography variant="h5" component="div" color="error" sx={{ mt: 1 }}>
                  {summary.autoPausedCount.toLocaleString()}
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                  Auto-paused sources
                </Typography>
              </>
            ) : null}
          </>
        )}
      </CardContent>
      <CardActions>
        <Button
          variant="outlined"
          component={Link}
          to="/beer-ingestion?tab=failures"
          fullWidth
        >
          View failures
        </Button>
      </CardActions>
    </DashboardSurfaceCard>
  );
}

export default BeerIngestionIssuesCard;
